<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import {useReportingStore} from "@/store/reporting";
import { computed } from "vue";
import UsageSummaryMetricTiles from "@/pages/Insights/ReportsDetailPage/components/UsageSummaryMetricTiles.vue";
import BaseReport from "@/pages/Insights/ReportsDetailPage/components/BaseReport.vue";
import UserSubjectChoicesDataTable from "@/pages/Insights/ReportsDetailPage/components/UserSubjectChoicesDataTable.vue";
import ReportDataTableLayout from "@/pages/Insights/ReportsDetailPage/components/ReportDataTableLayout.vue";

const reportingState = useReportingStore();
reportingState.resetState();

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "User Subject Choices", to: null }
]);

reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: true
});
</script>

<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">

    <page-header
      title="User Subject Choices"
      description="Explore user Subject Choice results"
    />

    <BaseReport
      data-endpoint="user-subject-choices"
      metric-endpoint="subject-choice-usage-ratio">

      <template #metric-content="{ metricData }">
        <UsageSummaryMetricTiles
          :data="metricData"
          category-title="Users"
          category-icon="fa fa-ticket"
          completed-label="Complete"
          pending-label="Incomplete"
          percentage-label="Completion Rate"
        />
      </template>

      <template #report-content="{ tableData, exportReport }">
        <div v-if="!reportingState.filters?.curriculum" class="text-center my-8">
          <h1>Please select a curriculum to see result breakdown.</h1>
        </div>
        <report-data-table-layout v-else @export-report="exportReport">
          <user-subject-choices-data-table
            :loading-data="false"
            :report-data="tableData"
            class="borderless"
            :curriculum="reportingState.filters?.curriculum"
          />
        </report-data-table-layout>
      </template>
    </BaseReport>
  </authenticated-layout>
</template>

<style scoped>

</style>
